module.exports = __webpack_public_path__ + "static/media/table.777ec84b.jpg";